import { Sifarnik } from "../../model/FinancialInformationType";
import { Country } from "../../model/PersonalInformationType";
import importedCountryHrLocaleData from "../../mock/countries-hr.json";
import importedCountryEnLocaleData from "../../mock/countries-en.json";
import importedPozivniBrojData from "../../mock/pozivni.json";
import { RadioGroupOption } from "../../component/common/RadioGroup";
import { SupportedLanguage } from "../../i18n";

export const SIFARNIK_STATUS_ZAPOSLENJA = [
    { id: "E", vrijednost: "financial-information-page.employment-status-field.options.full-time-employment" },
    { id: "S", vrijednost: "financial-information-page.employment-status-field.options.partial-employment" },
    { id: "L", vrijednost: "financial-information-page.employment-status-field.options.self-employed" },
    { id: "K", vrijednost: "financial-information-page.employment-status-field.options.entrepreneur" },
    { id: "O", vrijednost: "financial-information-page.employment-status-field.options.student" },
    { id: "H", vrijednost: "financial-information-page.employment-status-field.options.pupil" },
    { id: "A", vrijednost: "financial-information-page.employment-status-field.options.freelancer" },
    { id: "R", vrijednost: "financial-information-page.employment-status-field.options.pensioner" },
    { id: "U", vrijednost: "financial-information-page.employment-status-field.options.unemployed" }
] as Sifarnik[];

export const SIFARNIK_VRSTA_ZAPOSLJENJA = [
    { id: "01", vrijednost: "financial-information-page.employment-position-field.options.top-manager" },
    { id: "02", vrijednost: "financial-information-page.employment-position-field.options.middle-manager" },
    { id: "03", vrijednost: "financial-information-page.employment-position-field.options.entrepreneur" },
    { id: "04", vrijednost: "financial-information-page.employment-position-field.options.employee" },
    { id: "05", vrijednost: "financial-information-page.employment-position-field.options.other" }
] as Sifarnik[];

export const SIFARNIK_GOTOVINSKE_TRANSAKCIJE = [
    { id: "1", vrijednost: "financial-information-page.average-cash-transactions-field.options.up-to-1000" },
    { id: "2", vrijednost: "financial-information-page.average-cash-transactions-field.options.from-1000-to-10000" },
    { id: "3", vrijednost: "financial-information-page.average-cash-transactions-field.options.from-10000-to-50000" },
    { id: "4", vrijednost: "financial-information-page.average-cash-transactions-field.options.from-50000-to-100000" },
    { id: "5", vrijednost: "financial-information-page.average-cash-transactions-field.options.more-than-100000" }
] as Sifarnik[];

export const SIFARNIK_VRSTA_POSLODAVCA = [
    { id: "1", vrijednost: "financial-information-page.employer-type-field.options.public-enterprise" },
    { id: "2", vrijednost: "financial-information-page.employer-type-field.options.private-large" },
    { id: "3", vrijednost: "financial-information-page.employer-type-field.options.private-medium" },
    { id: "4", vrijednost: "financial-information-page.employer-type-field.options.private-small" },
    { id: "5", vrijednost: "financial-information-page.employer-type-field.options.craft" },
    { id: "6", vrijednost: "financial-information-page.employer-type-field.options.freelancer" },
    { id: "7", vrijednost: "financial-information-page.employer-type-field.options.other" }
] as Sifarnik[];

export const SIFARNIK_OCEKIVANI_PROMET = [
    { id: "1", vrijednost: "financial-information-page.expected-annual-turnover-field.options.up-to-70000" },
    { id: "2", vrijednost: "financial-information-page.expected-annual-turnover-field.options.up-to-150000" },
    { id: "3", vrijednost: "financial-information-page.expected-annual-turnover-field.options.up-to-500000" },
    { id: "4", vrijednost: "financial-information-page.expected-annual-turnover-field.options.up-to-1000000" },
    { id: "5", vrijednost: "financial-information-page.expected-annual-turnover-field.options.more-than-1000000" }
] as Sifarnik[];

export const SIFARNIK_PROSJECAN_IZNOS_OSTALIH_PRIHODA = [
    { id: "1", vrijednost: "financial-information-page.other-income-average-monthly-income-field.options.up-to-2000" },
    { id: "2", vrijednost: "financial-information-page.other-income-average-monthly-income-field.options.from-2000-to-5000" },
    { id: "3", vrijednost: "financial-information-page.other-income-average-monthly-income-field.options.more-than-5000" },
] as Sifarnik[];

export const SIFARNIK_PROSJECNA_PRIMANJA = [
    { id: "1", vrijednost: "financial-information-page.average-monthly-income-field.options.up-to-3000" },
    { id: "2", vrijednost: "financial-information-page.average-monthly-income-field.options.from-3000-to-10000" },
    { id: "3", vrijednost: "financial-information-page.average-monthly-income-field.options.more-than-10000" }
] as Sifarnik[];

export const SIFARNIK_IZVORA_OSTALIH_PRIHODA = [
    { id: '6', vrijednost: "financial-information-page.other-income-sources-field.options.no-income" },
    { id: "1", vrijednost: "financial-information-page.other-income-sources-field.options.freelance-work" },
    { id: "2", vrijednost: "financial-information-page.other-income-sources-field.options.author-work" },
    { id: "3", vrijednost: "financial-information-page.other-income-sources-field.options.side-job" },
    { id: "4", vrijednost: "financial-information-page.other-income-sources-field.options.disability-benefit" },
    { id: "5", vrijednost: "financial-information-page.other-income-sources-field.options.other" }
] as Sifarnik[];

export const SIFARNIK_SVRHE_RACUNA = [
    { id: "1", vrijednost: "financial-information-page.account-opening-purposes-field.options.receiving-pension-or-salary" },
    { id: "2", vrijednost: "financial-information-page.account-opening-purposes-field.options.cash-transactions" },
    { id: "3", vrijednost: "financial-information-page.account-opening-purposes-field.options.non-cash-transactions" },
    { id: "4", vrijednost: "financial-information-page.account-opening-purposes-field.options.cross-border-payments" },
    { id: "5", vrijednost: "financial-information-page.account-opening-purposes-field.options.investment-and-savings" },
    { id: "7", vrijednost: "financial-information-page.account-opening-purposes-field.options.credit" },
    { id: "8", vrijednost: "financial-information-page.account-opening-purposes-field.options.crypto-nft-investment" },
    { id: "6", vrijednost: "financial-information-page.account-opening-purposes-field.options.other" },
] as Sifarnik[];

export const SIFARNIK_VRSTE_TRANSAKCIJA = [
    { id: "1", vrijednost: "financial-information-page.account-transaction-types-field.options.cash-transactions" },
    { id: "2", vrijednost: "financial-information-page.account-transaction-types-field.options.non-cash-transactions" },
    { id: "3", vrijednost: "financial-information-page.account-transaction-types-field.options.cross-border-payments" },
    { id: "4", vrijednost: "financial-information-page.account-transaction-types-field.options.investment-and-savings" }
] as Sifarnik[];

export const SIFARNIK_PRILJEVA_SREDSTAVA = [
    { id: "1", vrijednost: "financial-information-page.funds-inflow-basics-field.options.regular-income" },
    { id: "2", vrijednost: "financial-information-page.funds-inflow-basics-field.options.personal-deposits" },
    { id: "3", vrijednost: "financial-information-page.funds-inflow-basics-field.options.third-party-deposits" },
    { id: "4", vrijednost: "financial-information-page.funds-inflow-basics-field.options.other" }
] as Sifarnik[];

export const SIFARNIK_KANAL_RAC_KART = [
    { id: "E", vrijednost: "E-mail" },
    { id: "B", vrijednost: "Poslovnica/elektronički kanali" },
    { id: "P", vrijednost: "Poštanska adresa" },
] as Sifarnik[];

export const SIFARNIK_KANAL_KRED_PREK = [
    { id: "E", vrijednost: "E-mail" },
    { id: "P", vrijednost: "Poštanska adresa" },
] as Sifarnik[];

export const SIFARNIK_KANAL_OPCI_DOK = [
    { id: "E", vrijednost: "E-mail" },
    { id: "P", vrijednost: "Poštanska adresa" },
] as Sifarnik[];

export const SIFARNIK_KANALI_DOSTAVE = [
    { id: "E", vrijednost: "marketing-consent-page.delivery-channels-field.options.email" },
    { id: "M", vrijednost: "marketing-consent-page.delivery-channels-field.options.mobile" },
    { id: "P", vrijednost: "marketing-consent-page.delivery-channels-field.options.phone" },
    { id: "L", vrijednost: "marketing-consent-page.delivery-channels-field.options.letter" },
] as Sifarnik[];

export const UKRAJINA_OZNAKA = "UA";

export const SAD_OZNAKA = "US";

export const SIFARNIK_UKRAJINA_REGIJA = [
    { id: "KRIM", vrijednost: "common.ukraine-region.options.krim" },
    { id: "SEVASTOPOLJ", vrijednost: "common.ukraine-region.options.sevastopolj" },
    { id: "DONJECK", vrijednost: "common.ukraine-region.options.donjeck" },
    { id: "HERSON", vrijednost: "common.ukraine-region.options.herson" },
    { id: "LUHANSK", vrijednost: "common.ukraine-region.options.luhansk" },
    { id: "ZAPORIZJE", vrijednost: "common.ukraine-region.options.zaporizje" },
    { id: "NISTA", vrijednost: "common.ukraine-region.options.none" },
] as Sifarnik[];

export const DOCUMENT_TYPE_RADIO_GROUP_OPTIONS: RadioGroupOption[] = [
    { value: "osobna", label: "upload-page.identification-document.ID-card.label" },
    { value: "putovnica", label: "upload-page.identification-document.passport.label" },
];

export const GENDER_RADIO_GROUP_OPTIONS: RadioGroupOption[] = [
    { value: "F", label: "personal-information-page.personal-information.gender-field.options.female" },
    { value: "M", label: "personal-information-page.personal-information.gender-field.options.male" },
];

export const COUNTRIES_DATA = (lng: SupportedLanguage) => {
  if (lng === "hr") {
    return importedCountryHrLocaleData && Array.isArray((importedCountryHrLocaleData as any).default)
      ? (importedCountryHrLocaleData as any).default as Country[]
      : Array.isArray(importedCountryHrLocaleData)
        ? (importedCountryHrLocaleData as Country[])
        : [];
  }

  return importedCountryEnLocaleData && Array.isArray((importedCountryEnLocaleData as any).default)
    ? (importedCountryEnLocaleData as any).default as Country[]
    : Array.isArray(importedCountryEnLocaleData)
      ? (importedCountryEnLocaleData as Country[])
      : [];
}

export const POZIVNI_BROJ_DATA: string[] =
  importedPozivniBrojData && Array.isArray((importedPozivniBrojData as any).default)
    ? (importedPozivniBrojData as any).default as string[]
    : Array.isArray(importedPozivniBrojData)
      ? (importedPozivniBrojData as string[])
      : [];
